import React from "react";

import Card from "../Card/Card";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import AddCircle from "@src/sharedComponents/Icons/AddCircle";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./EmptyCard.module.css";

interface Props {
  heading: string;
  text: string;
  onAdd: () => void;
  className?: string;
}

const EmptyCard: React.FC<Props> = ({ heading, text, onAdd, className }) => {
  return (
    <Card
      className={toClassName(styles.card, className)}
      onClick={onAdd}
      title={
        <div className={styles.icon}>
          <AddCircle />
        </div>
      }
      heading={<Text variant={"title2"}>{heading}</Text>}
      text={
        <Text variant="body" color={"textSubtle"}>
          {text}
        </Text>
      }
    />
  );
};

export default EmptyCard;
